function isLocalStorageAvailable(): boolean {
    return (
        typeof window !== "undefined" &&
        typeof window.localStorage !== "undefined"
    )
}

export function readLocalStorage<T>({
    key,
    parse,
}: {
    key: string
    parse: (raw: string) => T
}): T | null {
    try {
        if (!isLocalStorageAvailable()) return null
        const raw = localStorage.getItem(key)
        if (raw === null) return null
        return parse(raw)
    } catch {
        // localStorage can throw (Safari private mode, quota exceeded, disabled storage)
        // and parse can throw on malformed data; every caller already has a fallback.
        return null
    }
}

export function writeLocalStorage<T>({
    key,
    value,
}: {
    key: string
    value: T
}): void {
    try {
        if (!isLocalStorageAvailable()) return
        localStorage.setItem(
            key,
            typeof value === "string" ? value : JSON.stringify(value)
        )
    } catch {
        // Same justification as readLocalStorage above.
    }
}
